module.exports = "pegasus_template/assets/tech/basic_2/2.png";